<div class="loading-container" *ngIf="!isRapidScore">
    <div class="animation">
        <div class="oval">
            <img src="./assets/temporals/oval.png" alt="">
        </div>
        <img class="bicycle" src="./assets/temporals/shakira.png" alt="">
    </div>
    <div class="information">
        <div id="fadeIn" class="kpi">
            <p>{{ message }}<span>.</span><span>.</span><span>.</span></p>
        </div>
        <div class="added-account">
            <h2>{{ 'LOADING.ACCOUNT_ADDED' | translate }}</h2>
            <p class="text">{{ 'LOADING.TEXT' | translate }}<strong>{{ 'LOADING.STRONG_TEXT' | translate }}</strong></p>
            <p class="sub-text">{{ 'LOADING.SUB_TEXT' | translate }} <span>.</span><span>.</span><span>.</span></p>
        </div>
    </div>
</div>
<div class="loading-container-rapidScore" *ngIf="isRapidScore">
      <header  class="header" *ngIf="headerFooter">
        <div class="container-logo">
          <div class="logo"><img
              src="{{ './assets/logos/Logo_SCF_red.png' }}"
              [ngStyle]="{'cursor': 'auto', 'width':  '130px', 'padding': '0'}" alt="Logo_SCF_red"></div>
        </div>
      </header>
      <div class="body">
        <img src="./assets/login/loading-rapidScore.png" alt="loading-rapidScore">
        <div class="message">
            <strong>
              {{ 'LOADING.MOMENT' | translate }}
            </strong>
            <br>
            <p>
              {{ 'LOADING.CONNECTING' | translate }}
            </p>
            <mat-spinner color="warn"></mat-spinner>
        </div>
      </div>
</div>
